export default {
	title: 'D&P Planungsgesellschaft mbH',
	gsmaterials: {
		app: {
			scrollTop: {
				class: '[&_.iconify]:size-8 md:[&_.iconify]:size-10 lg:[&_.iconify]:size-12 bg-transparent shadow-none bottom-8 xs:bottom-12 sm:bottom-20 hover:bottom-22 lg:bottom-32 hover:lg:bottom-34 [&_.iconify]:text-primary hover:[&_.iconify]:text-primary/90 transition-all duration-300 ease-in-out',
				offset: 250,
				icon: 'lucide-chevron-up',
				color: 'primary',
				variant: 'solid'
			}
		},
		apiData: {
			profile: {
				url: '/rest/profiles',
				watch: false,
				query: () => {  return {id:  useRuntimeConfig().public.profileId}},
				frozen: ['id'],
				preload: true
			},
			homeslides: {
				url: '/rest/slideritems',
				query: () => { return { is_active: true, sort: 'position' }},
				frozen: ['is_active'],
				watch: false,
				preload: true
			},
			aboutTeasers: {
				url: '/rest/about-teasers',
				query: () => { return { is_active: true, sort: 'position' }},
				frozen: ['is_active'],
				watch: false,
				preload: true
			},
			projects: {
				url: '/rest/projects',
				query: () => { return { is_active: true, sort: '-implementation_date,title', page_size: 30, page: 1 }},
				watch: true,
				dataKey: false,
				frozen: ['is_active', 'page_size', 'sort'],
			},
			currentProjects: {
				url: '/rest/projects',
				query: () => { return { is_active: true, is_current: true, sort: '-implementation_date,title' }},
				frozen: ['is_active']
			},
			featuredProjects: {
				url: '/rest/projects',
				query: () => { return { is_active: true, is_featured: true, sort: '-implementation_date,title' }},
				frozen: ['is_active']
			}
		}
	},
	ui: {
		button: {
			base: 'transition duration-500 ease-in-out',
			defaultVariants: {
				size: '2xl',
				color: 'primary',
				variant: 'solid'
			},
			compoundVariants: [
				{
					color: 'primary',
					variant: 'solid',
					class: 'inline-block cursor-pointer [&_span]:font-light [&_span]:leading-tight [&_span]:text-[1rem] md:[&_span]:text-[1.15rem] xl:[&_span]:text-[1.25rem] [@media(min-width:2100px)]:[&_span]:text-[1.5rem] [&_span]:text-white border group rounded-none px-4 lg:px-6 py-2 border-primary hover:[&_span]:text-primary hover:border-primary bg-primary hover:bg-white'
				},
				{
					color: 'primary',
					variant: 'link',
					class: '[&_.iconify]:text-primary hover:[&_.iconify]:text-primary-100 transition-all duration-300 ease-in-out'
				},
			]
		},
		formField: {
			slots: {
				labelWrapper: 'leading-6',
				label: 'font-poppins font-light text-gray text-[1rem] xl:text-[1.15rem] [@media(min-width:2100px)]:text-[1.375rem]'
			}
		},
		input: {
			slots: {
				base: 'font-poppins font-light text-[1rem] md:text-[1.2rem] rounded-none bg-gray-100! ring-1! border-0 ring-gray-100! focus:ring-primary/50! focus:ring-1 focus:ring-offset-0',
			},
			defaultVariants: {
				size: 'xl',
				color: 'neutral'
			}
		},
		checkbox: {
			slots: {
				base: 'cursor-pointer',
				label: 'font-light text-[0.9rem] md:text-[1rem] -mt-1 cursor-pointer',
				container: 'flex items-start'
			},
			defaultVariants: {
				size: 'xl',
				color: 'primary',
				variant: 'list',
				indicator: 'start'
			}
		},
		textarea: {
			slots: {
				base: 'font-poppins font-light text-[1rem] md:text-[1.2rem] rounded-none bg-gray-100! ring-1! ring-gray-100! focus:ring-primary/50! focus:ring-1 focus:ring-offset-0',
			},
			defaultVariants: {
				size: 'xl',
				color: 'neutral'
			}
		},
		carousel: {
			variants: {
		 		active: {
			 		true: {
				 		dot: 'bg-primary! size-4'
				 	}
			 	}
			}
		}
	}
}
